export default __webpack_public_path__ + "static/icon-46af3b90d6453c85f8e11280dda53169.png";